import template117 from './template_117';
import template118 from './template_118';
import template119 from './template_119';

const registry = {
  117: template117,
  118: template118,
  119: template119,
};

export default function getTemplate(instituteId) {
  return registry[instituteId] || registry[117];
}
